import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { OperatorVehicleModel } from 'app/models';
import {
	OperatorVehicleRidersQuery,
	OperatorVehiclesListRequest,
	OperatorVehiclesListResponse,
	PagedListResponse
} from 'app/models/operator/operator-vehicles-query.model';
import { OperatorService } from '../operator.service';
import { RiderService } from '../rider-service';

@Injectable({
	providedIn: 'root'
})
export class OperatorVehiclesService {

	constructor(
		private operatorService: OperatorService,
		private riderService: RiderService
	) { }

	async getVehicles(
		request: OperatorVehiclesListRequest,
		messageService: MessageService
	): Promise<OperatorVehiclesListResponse> {
		const data = await this.operatorService.getOperatorVehicles(
			{ IsActive: request.isActive },
			messageService
		);

		if (!data?.Success) {
			throw new Error(data?.ErrorMessage ?? 'Failed to load vehicles');
		}

		return {
			items: (data.Items ?? []).map((item: Record<string, unknown>) => new OperatorVehicleModel(item)),
			totalRecords: data.TotalRecords ?? 0
		};
	}

	async getVehicleRiders(
		query: OperatorVehicleRidersQuery,
		messageService: MessageService
	): Promise<PagedListResponse<unknown>> {
		const data = await this.riderService.getRidersByVehicle({
			VehicleId: query.vehicleId,
			Search: query.search ?? null,
			Skip: query.skip,
			Take: query.take,
			SortField: query.sortField,
			SortOrder: query.sortOrder
		}, messageService);

		if (!data?.Success) {
			return {
				items: [],
				totalRecords: 0,
				success: false,
				errorMessage: data?.ErrorMessage
			};
		}

		return {
			items: data.Items ?? [],
			totalRecords: data.TotalRecords ?? 0,
			success: true
		};
	}
}
